import { render, staticRenderFns } from "./DigitalRepliesSearch.vue?vue&type=template&id=bcfac7a2&"
import script from "./DigitalRepliesSearch.vue?vue&type=script&lang=js&"
export * from "./DigitalRepliesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports